<svelte:head>
  <title>Preferences | A Good Thing</title>
</svelte:head>

{#if data.preferences}
<div class="subtitle">Notifications</div>
<div class="field is-horizontal">
  <div class="control">
      <input id="notify" bind:checked={data.preferences.charityNotifyOffers} type="checkbox" class="switch is-success" on:change={save}>
      <label for="notify">Email me about new offers</label>
  </div>
</div>
{/if}

<hr />
<div class="subtitle">Delete account</div>
<div class="block">This cannot be undone.</div>
<div class="field is-horizontal">
  <div class="control">
    <button class="button" on:click={() => {
      $uiState.activeModal = {
        component: ConfirmDeleteUser,
        props: { userId, gotoPath: '/goodbye' }
      };
    }}>Delete account</button>
  </div>
</div>

<script lang="ts">
  import _ from "lodash";
  import { appState } from "../../../lib/appState";
  import { uiState } from '../../../lib/uiState';
  import ConfirmDeleteUser from './_components/ConfirmDeleteUser.svelte';

  let data = _.cloneDeep($appState.user) as User_v1;

  let userId = $appState.auth_user.email;

  if (data.preferences == undefined) {
    data.preferences = {};
  }

  if(data.preferences.charityNotifyOffers == undefined) {
    data.preferences.charityNotifyOffers = true;
  } 

  let showToast = false;

  let isLoading = false;

  let firebase = window.firebase;

  async function save() {
    isLoading = true;

    await firebase
      .firestore()
      .collection("users_v1")
      .doc($appState.auth_user.email)
      .update(data);

    $appState.user = data;

    isLoading = false;

    showToast = true;
  }
</script>
